import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { IMGIX_URL } from '@src/env';

const TECH_AND_FINANCE_GIF = `${IMGIX_URL}/global/subscribe/tech_and_finance.gif`;

const TechAndFinance = () => {
  return (
    <div className="mx-auto my-8 mt-64 flex max-w-[856px] flex-col gap-48 sm:mt-96 sm:flex-row md:flex-row md:gap-64 lg:gap-80">
      <LazyImgixImage
        src={TECH_AND_FINANCE_GIF}
        className="h-full w-full"
        wrapperClassName="!flex xl:w-[292px] md:w-[280px] sm:w-[316px] w-[324px] shrink-0 aspect-[292/600] self-center sm:self-start"
        role="presentation"
      />
      <div>
        <h2 className="m-0 font-suisse-works text-headline-xs text-black md:text-headline-sm">
          <span className="font-bold italic text-primary-magenta">Tech </span>is in Our DNA
        </h2>
        <div className="mb-0 mt-8 font-suisse-intl text-body-md font-light text-black sm:text-body-lg">
          We were founded to report on:
          <ul className="m-0 pl-16 marker:text-primary-magenta sm:p-0">
            <li>
              The leading edge of technology, and how it influences just about everything else in
              our lives and world.
            </li>
            <li>
              Early scoop on billions of dollars of acquisitions and what’s happening deep inside
              companies like Apple, Facebook and Google.
            </li>
            <li>
              Ambitious coverage of the rise of AI and will continue to prepare our readers for
              whatever comes next.
            </li>
          </ul>
        </div>
        <div className="border-t-10 my-24 w-[100px] border-solid border-primary-magenta md:my-32" />
        <h2 className="m-0 font-suisse-works text-headline-xs text-black md:text-headline-sm">
          Focus on <span className="font-bold italic text-primary-magenta">Finance</span>
        </h2>
        <p className="mb-0 mt-8 font-suisse-intl text-body-md font-light text-black sm:text-body-lg">
          Our finance team has emerged as a powerful player shaping the global conversation,
          specifically within venture capital and fintech. Our relationships with the biggest
          players in the industry gives us unparalleled ability to report on the state of public vs.
          private companies, delve into finance’s crypto strategy and unveil a series of regulatory
          missteps in the murky world of fintechs and community banks.
        </p>
      </div>
    </div>
  );
};

export default TechAndFinance;
